<template>
    <div id="app">
        <loading></loading>
        <modal></modal>
        <confirm></confirm>
        <confirmCountdown></confirmCountdown>
        <uploadAnswerFile></uploadAnswerFile>
        <updateAnswerFile></updateAnswerFile>
        <userBroadcastMessages></userBroadcastMessages>
        <consultReason></consultReason>
        <router-view/>
    </div>
</template>

<script>
import './main.css'
import constants from './constants'
export default {
  name: 'App',
  data () {
    return {
    }
  },
  created () {
    this.setCopies()
  },
  methods: {
    setCopies () {
      let language = localStorage.getItem('language') || constants.languages[0]
      constants.setCopies(language)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue